import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=51c3271d&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c3271d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c3271d')) {
      api.createRecord('51c3271d', component.options)
    } else {
      api.reload('51c3271d', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=51c3271d&scoped=true&", function () {
      api.rerender('51c3271d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28LdKzJa255hE/JS/comp/Voucher-Unit.vue"
export default component.exports